__turbopack_context__.v({
  "buttonWrapper": "TeamsUpsell-module__p4hgSq__buttonWrapper",
  "root": "TeamsUpsell-module__p4hgSq__root",
  "textWrapper": "TeamsUpsell-module__p4hgSq__textWrapper",
});
